<template>
	<div class="box">
		<div class="contaner-title">
			<span>供应商管理</span> <span>/ 供应商列表</span>
		</div>
		<div class="hr"></div>
		<Row>
			<Col span="3">
			<Input v-model="keyword" placeholder="请输入关键字" @on-enter="searchData" />
			</Col>
			<Col span="3">
			<Select v-model="userName" placeholder="认证状态">
				<img src="../../assets/status.png" slot="prefix" alt="" />
				<Option :value="4">全部</Option>
				<Option :value="0">资料未完善</Option>
				<Option :value="1">未认证</Option>
				<Option :value="2">待审核</Option>
				<Option :value="3">审核通过</Option>
			</Select>
			</Col>
			<Col span="1">
			<Button type="primary">
				<icon size="20" type="ios-search" @click.native="searchData" />
			</Button>
			</Col>
		</Row>
		<Row>
			<Collapse simple v-model="openPanel">
				<Panel name="1">
					擅长项目标签
					<div slot="content">
						<div class="searchcondition flex flex-ver">
							<span>2D</span>
							<Checkbox border :indeterminate="indeterminate1" :value="check2DAll" @click.prevent.native="handleCheck2DAll">全选</Checkbox>
							<CheckboxGroup v-model="check2DAllGroup" @on-change="funccheck2DAll">
								<Checkbox border label="2D-设计稿">设计稿</Checkbox>
								<Checkbox border label="2D-一原">一原</Checkbox>
								<Checkbox border label="2D-二原">二原</Checkbox>
								<Checkbox border label="2D-动上">动上</Checkbox>
								<Checkbox border label="2D-摄影">摄影</Checkbox>
								<Checkbox border label="2D-背景">背景</Checkbox>
							</CheckboxGroup>
						</div>
						<div class="searchcondition flex flex-ver">
							<span>3D</span>
							<Checkbox border :indeterminate="indeterminate2" :value="check3DAll" @click.prevent.native="handleCheck3DAll">全选</Checkbox>
							<CheckboxGroup v-model="check3DAllGroup" @on-change="funccheck3DAll">
								<Checkbox border label="3D-人物模型">人物模型</Checkbox>
								<Checkbox border label="3D-人物材质">人物材质</Checkbox>
								<Checkbox border label="3D-场景模型">场景模型</Checkbox>
								<Checkbox border label="3D-场景材质">场景材质</Checkbox>
								<Checkbox border label="3D-绑定">绑定</Checkbox>
								<Checkbox border label="3D-动画">动画</Checkbox>
								<Checkbox border label="3D-特效">特效</Checkbox>
								<Checkbox border label="3D-灯光">灯光</Checkbox>
								<Checkbox border label="3D-渲染">渲染</Checkbox>
							</CheckboxGroup>
						</div>
						<div class="searchcondition flex flex-ver">
							<span>平面</span>
							<Checkbox border :indeterminate="indeterminate3" :value="checkplaneAll" @click.prevent.native="handleCheckplaneAll">全选</Checkbox>
							<CheckboxGroup v-model="checkplaneAllGroup" @on-change="funccheckplaneAll">
								<Checkbox border label="平面-海报">海报</Checkbox>
								<Checkbox border label="平面-插画">插画</Checkbox>
								<Checkbox border label="平面-立绘">立绘</Checkbox>
							</CheckboxGroup>
						</div>
						<div class="searchcondition flex flex-ver">
							<span>大后期</span>
							<Checkbox border :indeterminate="indeterminate4" :value="checkstageAll" @click.prevent.native="handleCheckstageAll">全选</Checkbox>
							<CheckboxGroup v-model="checkstageAllGroup" @on-change="funccheckstageAll">
								<Checkbox border label="大后期-配音">配音</Checkbox>
								<Checkbox border label="大后期-音乐">音乐</Checkbox>
								<Checkbox border label="大后期-音效/混音">音效/混音</Checkbox>
							</CheckboxGroup>
						</div>
						<div class="searchcondition flex flex-ver">
							<span>前期</span>
							<Checkbox border :indeterminate="indeterminate5" :value="checkearlfystageAll" @click.prevent.native="handleCheckearlystageAll">全选</Checkbox>
							<CheckboxGroup v-model="checkearlystageAllGroup" @on-change="funccheckearlfystageAll">
								<Checkbox border label="前期-分镜">分镜</Checkbox>
								<Checkbox border label="前期-剧本">剧本</Checkbox>
								<Checkbox border label="前期-人设">人设</Checkbox>
								<Checkbox border label="前期-场设">场设</Checkbox>
								<Checkbox border label="前期-道具">道具</Checkbox>
							</CheckboxGroup>
						</div>
						<div class="searchcondition flex flex-ver">
							<span>其他</span>
							<Checkbox border :indeterminate="indeterminate6" :value="checkotherAll" @click.prevent.native="handleCheckotherAll">全选</Checkbox>
							<CheckboxGroup v-model="checkotherAllGroup" @on-change="funccheckotherAll">
								<Checkbox border label="其他">其他</Checkbox>
								<Checkbox border label="3渲2">3渲2</Checkbox>
							</CheckboxGroup>
						</div>
					</div>
				</Panel>
			</Collapse>
		</Row>
		<div class="tab">
			<Table :row-class-name="rowClassName" :columns="columns1" :data="data1"></Table>
			<div style="text-align: right; padding: 30px 0px">
				<Page :total="Count" @on-change="changePage" />
			</div>
		</div>
		<Modal v-model="showDetail" :closable="false" width="765" :styles="{top: '40px'}">
			<div slot="header" class="header-modal">
				<img src="../../assets/detail.png" alt="" />
				<span>用户详情</span>
				<img class="close" @click="showDetail = false" src="../../assets/close.png" alt="" />
			</div>
			<div class="content-modal table-c">
				<Tabs value="name1">
					<TabPane label="基本信息" name="name1">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td class="label" width="100">用户ID</td>
								<td width="140">{{ Detail.ID }}</td>
								<td class="label" width="100">联系人</td>
								<td width="140">{{ Detail.Realname }}</td>
								<td class="label" width="100">手机号</td>
								<td width="140">
									{{ Detail.TelCode }} {{ Detail.Tel }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">邮箱</td>
								<td width="140">{{ Detail.Email }}</td>
								<td class="label" width="100">QQ</td>
								<td width="140">{{ Detail.QQ }}</td>
								<td class="label" width="100">微信</td>
								<td width="140">{{ Detail.WX }}</td>
							</tr>
							<tr>
								<td class="label" width="100">认证状态</td>
								<td width="140">
									<span v-if="Detail.Status == 0">资料未完善</span>
									<span v-if="Detail.Status == 1">未认证</span>
									<span v-if="Detail.Status == 2">待审核</span>
									<span v-if="Detail.Status == 3">审核通过</span>
								</td>
								<td class="label" width="100">供应商评级</td>
								<td width="140">{{ Detail.SupplierRate }}</td>
								<td class="label" width="100">完成项目数</td>
								<td width="140">
									{{ Detail.FinishProjectNum.length }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">擅长项目</td>
								<td width="140" colspan="2">
									<span v-if="Detail.Fields">
										<span v-for="(ite, index) in Detail.Fields" :key="index">{{ ite }} ,</span>
									</span>
								</td>
								<td class="label" width="100">累计完成金额</td>
								<td width="140" colspan="2">
									{{ Detail.Amount_Total }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">技能标签</td>
								<td width="140" colspan="5">
									{{ Detail.Skill }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">工作地</td>
								<td width="140" colspan="5">
									{{ Detail.place }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">支付宝</td>
								<td width="140" colspan="5">
									{{ Detail.Alipay }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">银行卡号</td>
								<td width="140" colspan="5">
									<span v-if="Detail.Bank">
										{{Detail.Bank.Account}}
									</span>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">户名</td>
								<td width="140" colspan="5">
									<span v-if="Detail.Bank">
										{{Detail.Bank.Name}}
									</span>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">开户行</td>
								<td width="140" colspan="5">
									<span v-if="Detail.Bank">
										{{Detail.Bank.Username}}
									</span>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">备注</td>
								<td width="140" colspan="5">
									<span v-if="Detail.Comment">
										{{Detail.Comment}}
									</span>
								</td>
							</tr>
						</table>
					</TabPane>
					<TabPane label="用户认证" name="name2">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr>
								<td class="label" width="100">供应商类型</td>
								<td width="280" colspan="2">
									<span v-if="Detail.VerifyType == 1">个人</span><span v-if="Detail.VerifyType == 2">工作室 / 公司</span>
								</td>
								<td class="label" width="100">规模</td>
								<td width="280" colspan="2">
									{{ Detail.Scale }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">有效证件</td>
								<td width="140" colspan="5" height="119">
									<div v-if="Detail.Certificate">
										<img style="width: 154px;height: 94px; cursor: pointer;" @click="checkImg(item, index)" v-for="(item, index) in Detail.Certificate" :key="index" :src="imgUrl + item" alt="" />
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">企业名称</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.CompanyName }}
									</div>
								</td>
								<td class="label" width="100">企业住所</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.CompanyAddress }}
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">企业法人</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.CompanyLeader }}
									</div>
								</td>
								<td class="label" width="100">
									社会统一信用代码
								</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.CompanyCode }}
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">企业成立时间</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.CompanyDate }}
									</div>
								</td>
								<td class="label" width="100">通讯地址</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.TelAddress }}
										{{ Detail.DetailedAddress }}
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">联系人</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.ContactName }}
									</div>
								</td>
								<td class="label" width="100">联系方式</td>
								<td width="280" colspan="2">
									<div>
										{{ Detail.ContactWay }}
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">项目经历</td>
								<td width="140" colspan="5" height="108" style="text-align: left; vertical-align: initial;">
									{{ Detail.ItemProcess }}
								</td>
							</tr>
							<tr>
								<td class="label" width="100">作品展示</td>
								<td width="140" colspan="5">
									<div v-if="Detail.FilePath" class="workDisplay" style="cursor: pointer; text-align: left;">
										<p @click="download(item)" v-for="(item, index) in FilePath" :key="index">
											{{ item.Name }}
										</p>
									</div>
								</td>
							</tr>
							<tr>
								<td class="label" width="100">供应商评级</td>
								<td width="140" colspan="2">
									<!-- <Select
										style="width: 150px"
										v-model="Detail.SupplierRate"
									>
										<Option value="一星">一星</Option>
										<Option value="二星">二星</Option>
										<Option value="三星">三星</Option>
										<Option value="四星">四星</Option>
										<Option value="五星">五星</Option>
									</Select> -->
									<Rate v-model="Detail.SupplierRate" />
								</td>
								<td class="label" width="100">信息备注</td>
								<td width="140" colspan="2">
									<Input style="width: 150px" v-model="Detail.Comment"></Input>
								</td>
							</tr>
						</table>
						<div style="
								margin: 20px 50px;
								text-align: center;
								padding: 0px;
							">
							<Button type="success" style="margin-right: 20px" @click="confirmVerify(3)" v-if="Detail.Status != 1 && Detail.Status != 0">认证通过</Button>
							<Button type="error" v-if="Detail.Status != 1 && Detail.Status != 0" @click="cancelVerify">取消认证</Button>
						</div>
					</TabPane>
					<TabPane label="已完结" name="name3" class="tab">
						<Table :row-class-name="rowClassName" :columns="columns" :show-header="false" :data="data"></Table>
					</TabPane>
					<TabPane label="竞标中" name="name4" class="tab">
						<Table :row-class-name="rowClassName" :columns="columns" :show-header="false" :data="data"></Table>
					</TabPane>
				</Tabs>
			</div>
			<div slot="footer" style="display: none;">
				<Button type="info" @click="showDetail = false">关闭</Button>
			</div>
		</Modal>
		<Modal v-model="showPortrait" width="800">
			<div>
				<Carousel :value="valueProtrait" style="width: 800px" dots="outside">
					<CarouselItem v-for="(item, index) in Detail.Certificate" :key="index" style="width: 800px">
						<div class="demo-carousel">
							<img :src="imgUrl + item" style="width: 100%" />
						</div>
					</CarouselItem>
				</Carousel>
			</div>
		</Modal>
		<Modal v-model="showRemark" :closable="false">
			<div slot="header" class="header-modal">
				<span>取消认证</span>
				<img class="close" @click="showRemark = false" src="../../assets/close.png" alt="" />
			</div>
			<div style="margin: 20px">
				<Input v-model="Remark"></Input>
			</div>
			<div slot="footer">
				<Button @click="showRemark = false">关闭</Button>
				<Button type="success" @click="cancelVer">确定</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
export default {
	data() {
		return {
			searchArr: [],
			indeterminate1: false,
			indeterminate2: false,
			indeterminate3: false,
			indeterminate4: false,
			indeterminate5: false,
			indeterminate6: false,
			check2DAll: false,
			check2DAllGroup: [],
			check3DAll: false,
			check3DAllGroup: [],
			checkplaneAll: false,
			checkplaneAllGroup: [],
			checkstageAll: false,
			checkstageAllGroup: [],
			checkearlfystageAll: false,
			checkearlystageAllGroup: [],
			checkotherAll: false,
			checkotherAllGroup: [],
			arr2D: ['2D-设计稿', '2D-一原', '2D-二原', '2D-动上', '2D-摄影', '2D-背景'],
			arr3D: ['3D-人物模型', '3D-人物材质', '3D-场景模型', '3D-场景材质', '3D-绑定', '3D-动画', '3D-特效', '3D-灯光', '3D-渲染'],
			arrplane: ['平面-海报', '平面-插画', '平面-立绘'],
			arrstage: ['大后期-配音', '大后期-音乐', '大后期-音效/混音'],
			arrearlystage: ['前期-分镜', '前期-剧本', '前期-人设', '前期-场设', '前期-道具'],
			arrother: ['其他', '3渲2'],
			openPanel: [1],
			PID: '',
			showRemark: false,
			valueProtrait: 0,
			showPortrait: false,
			imgUrl: this.$baseImg,
			showDetail: false,
			userName: '',//认证状态
			columns: [
				{
					title: '用户名',
					key: 'Realname',
					align: 'left',
					width: 600,
				},
				{
					title: '最后登录时间',
					key: 'LastLoginTime',
					align: 'center',
				}
			],
			data: [{
				name: '游戏模型场景模型三维动画制作建模3D动画视频特效     ',
				date: '2019-12-12'
			}, {
				name: '游戏模型场景模型三维动画制作建模3D动画视频特效     ',
				date: '2019-12-12'
			}, {
				name: '游戏模型场景模型三维动画制作建模3D动画视频特效     ',
				date: '2019-12-12'
			}, {
				name: '游戏模型场景模型三维动画制作建模3D动画视频特效     ',
				date: '2019-12-12'
			}],
			columns1: [
				{
					title: '联系人',
					key: 'Realname',
					align: 'center',
					width: 80,
				},
				{
					title: '手机号',
					key: 'Tel',
					width: 150,
					align: 'center',
					render: (h, params) => {
						return h('span', {
							style: {

							}

						}, params.row.TelCode + params.row.Tel)
					}
				},
				{
					title: '企业名称',
					key: 'CompanyName',
					align: 'center',
					width: 250
				},
				{
					title: '擅长项目',
					key: 'Fields',
					align: 'center',
					render: (h, params) => {
						var arr = [];
						if (params.row.Fields) {
							params.row.Fields.forEach(item => {
								if (item.indexOf("sign") != -1) {
									arr.push(h('span', {
										style: {
											color: 'red'
										}
									}, item.split('sign')[0] + ','))
								} else {
									arr.push(h('span', {
										style: {

										}
									}, item + ','))
								}
							})
						}

						return h('span', {
							style: {

							}

						}, arr)
					}
				},
				{
					title: '所在地',
					key: 'Address',
					width: 100,
					align: 'center',
					render: (h, params) => {
						//  console.log(this.$pcaa[86][330000])
						//  console.log(this.$pcaa[330000][330100])
						//  console.log(this.$pcaa[330100][330105])
						// this.$pcaa[params.row.Address.City][params.row.Address.Area]//区
						var text = '';
						if (params.row.Address) {
							text = this.$pcaa[86][params.row.Address.Province] + this.$pcaa[params.row.Address.Province][params.row.Address.City]
							return h('span', {
								attrs: {
									title: this.$pcaa[86][params.row.Address.Province] + this.$pcaa[params.row.Address.Province][params.row.Address.City] + this.$pcaa[params.row.Address.City][params.row.Address.Area],
								},
								on: {
									"click": () => {

									}
								}
							}, text)
						}
					}
				},
				{
					title: '最后登录时间',
					key: 'LastLoginTime',
					align: 'center',
					width: 90
				},
				{
					title: '备注',
					key: 'Comment',
					align: 'center',
					render: (h, params) => {
						let arr = [];
						arr.push(h('span', {
							style: {
							}
						}, params.row.CommentKbefore));
						arr.push(h('span', {
							style: {
								color: 'red'
							}
						}, params.row.CommentKeyword));
						arr.push(h('span', {
							style: {
							}
						}, params.row.CommentKafter));
						return h('span', {
							style: {
							}
						}, arr)
					}
				},
				{
					title: '提醒',
					key: 'RemindNum',
					align: 'center',
					width: 80
				},
				{
					title: '认证状态',
					key: 'Status',
					width: 120,
					align: 'center',
					render: (h, params) => {
						var text = "";
						if (params.row.Status == 0) {
							text = "资料未完善";
						} else if (params.row.Status == 1) {
							text = "未认证";
						} else if (params.row.Status == 2) {
							text = "待审核";
						} else if (params.row.Status == 3) {
							text = "审核通过";
						}
						return h('span', {
							style: {
								color: params.row.status == 1 ? '#008C00' : '#FF0000'
							}

						}, text)
					}
				},
				{
					title: '操作',
					align: 'center',
					width: 200,
					render: (h, params) => {
						if (params.row.Status == 1 || params.row.Status == 0) {
							return h('div', [
								h('Button', {
									props: {
										type: 'success',
										size: 'small'
									},
									on: {
										"click": () => {
											this.getDetail(params.row)
										}
									}
								}, '查看详情'),
								h('Button', {
									style: {
										"margin-left": "10px"
									},
									props: {
										type: 'error',
										size: 'small'
									},
									on: {
										"click": () => {
											this.tips(params.row)
										}
									}
								}, '提醒')
							])
						} else {
							if (this.PID) {
								return h('div', [
									h('Button', {
										props: {
											type: 'success',
											size: 'small'
										},
										on: {
											"click": () => {
												this.getDetail(params.row)
											}
										}
									}, '查看详情'),
									h('Button', {
										style: {
											"margin-left": "10px"
										},
										props: {
											type: 'error',
											size: 'small'
										},
										on: {
											"click": () => {
												this.invite(params.row)
											}
										}
									}, '邀请竞标')
								])
							} else {
								return h('Button', {
									props: {
										type: 'success',
										size: 'small'
									},
									on: {
										"click": () => {
											this.getDetail(params.row)
										}
									}
								}, '查看详情')
							}
						}

					}
				},
			],
			data1: [],
			Count: 0,
			page: 1,
			pageSize: 10,
			keyword: '',
			Detail: { FinishProjectNum: [], SupplierRate: 0 },
			Remark: '',
			UserID: 0,
			FilePath: [],
		}
	},
	mounted() {
		this.PID = this.$route.query.PID;
		this.getData();
	},
	methods: {
		// 分类搜索
		handleCheckAll(indeterminate, checkAll, arr) {
			if (indeterminate) {
				checkAll = false;
			} else {
				checkAll = !checkAll;
			}
			indeterminate = false;

			if (checkAll) {
				var checkAllGroup = arr;
			} else {
				var checkAllGroup = [];
			}
			var obj = { checkAll, indeterminate, checkAllGroup }
			return obj
		},
		checkAllGroupChange(data, indeterminate, checkAll, num) {
			if (data.length === num) {
				indeterminate = false;
				checkAll = true;
			} else if (data.length > 0) {
				indeterminate = true;
				checkAll = false;
			} else {
				indeterminate = false;
				checkAll = false;
			}
			var obj = { indeterminate, checkAll }
			return obj
		},
		getSerachCheck(data) {
			var params = {
				page: this.page,
				pageSize: this.pageSize,
				Fields: data,
				keyword: '',
				Status: ''
			}
			this.$post('api/manage.SupplierManage/supplierList', params).then(res => {
				if (res.code == 1) {
					this.data1 = res.data.data;
					for (var i of this.data1) {
						for (var j in i.Fields) {
							for (var n of data) {
								if (i.Fields[j] == n) {
									i.Fields[j] = i.Fields[j] + 'sign'
								}
							}
						}
					}
					this.Count = res.data.all_num;
				}
			})
		},
		funcarrduplication(checkAllGroup, arr) {
			for (var i of checkAllGroup) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			if (checkAllGroup.length === 0) {
				for (var i in this.searchArr) {
					for (var j of arr) {
						if (this.searchArr[i] == j) {
							this.searchArr.splice(i, 1)
						}
					}
				}
			}
			this.getSerachCheck(this.searchArr)
		},
		funcCheckData(arr) {
			for (var j of arr) {
				for (var i in this.searchArr) {
					if (this.searchArr[i] == j) {
						this.searchArr.splice(i, 1)
					}
				}
			}
		},
		handleCheck2DAll() {
			var arr = this.arr2D
			var obj = this.handleCheckAll(this.indeterminate1, this.check2DAll, arr)
			this.check2DAll = obj.checkAll
			this.check2DAllGroup = obj.checkAllGroup
			this.indeterminate1 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		handleCheck3DAll() {
			var arr = this.arr3D
			var obj = this.handleCheckAll(this.indeterminate2, this.check3DAll, arr)
			this.check3DAll = obj.checkAll
			this.check3DAllGroup = obj.checkAllGroup
			this.indeterminate2 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		handleCheckplaneAll() {
			var arr = this.arrplane
			var obj = this.handleCheckAll(this.indeterminate3, this.checkplaneAll, arr)
			this.checkplaneAll = obj.checkAll
			this.checkplaneAllGroup = obj.checkAllGroup
			this.indeterminate3 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		handleCheckstageAll() {
			var arr = this.arrstage
			var obj = this.handleCheckAll(this.indeterminate4, this.checkstageAll, arr)
			this.checkstageAll = obj.checkAll
			this.checkstageAllGroup = obj.checkAllGroup
			this.indeterminate4 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		handleCheckearlystageAll() {
			var arr = this.arrearlystage
			var obj = this.handleCheckAll(this.indeterminate5, this.checkearlfystageAll, arr)
			this.checkearlfystageAll = obj.checkAll
			this.checkearlystageAllGroup = obj.checkAllGroup
			this.indeterminate5 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		handleCheckotherAll() {
			var arr = this.arrother
			var obj = this.handleCheckAll(this.indeterminate6, this.checkotherAll, arr)
			this.checkotherAll = obj.checkAll
			this.checkotherAllGroup = obj.checkAllGroup
			this.indeterminate6 = obj.indeterminate
			this.funcarrduplication(obj.checkAllGroup, arr)
		},
		funccheck2DAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate1, this.check2DAll, 6)
			this.check2DAll = obj.checkAll
			this.indeterminate1 = obj.indeterminate
			this.funcCheckData(this.arr2D)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		funccheck3DAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate2, this.check3DAll, 9)
			this.check3DAll = obj.checkAll
			this.indeterminate2 = obj.indeterminate
			this.funcCheckData(this.arr3D)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		funccheckplaneAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate3, this.checkplaneAll, 3)
			this.checkplaneAll = obj.checkAll
			this.indeterminate3 = obj.indeterminate
			this.funcCheckData(this.arrplane)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		funccheckstageAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate4, this.checkstageAll, 3)
			this.checkstageAll = obj.checkAll
			this.indeterminate4 = obj.indeterminate
			this.funcCheckData(this.arrstage)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		funccheckearlfystageAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate5, this.checkearlfystageAll, 5)
			this.checkearlfystageAll = obj.checkAll
			this.indeterminate5 = obj.indeterminate
			this.funcCheckData(this.arrearlystage)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		funccheckotherAll(data) {
			var obj = this.checkAllGroupChange(data, this.indeterminate6, this.checkotherAll, 2)
			this.checkotherAll = obj.checkAll
			this.indeterminate6 = obj.indeterminate
			this.funcCheckData(this.arrother)
			for (var i of data) {
				this.searchArr.push(i)
			}
			this.searchArr = Array.from(new Set(this.searchArr))
			this.getSerachCheck(this.searchArr)
		},
		//邀请竞标
		invite(row) {
			var params = {
				ProjectID: this.PID,
				MemberID: row.ID
			}
			this.$post('api/manage.ProjectManage/inviteProjectMember', params).then(res => {
				if (res.code == 1) {
					this.$Message.success(res.msg);
				} else {
					this.$Message.error(res.msg);
				}
			})
		},
		searchData() {
			this.page = 1;
			this.getData();
		},
		changePage(val) {
			this.page = val;
			this.getData();
		},
		tips(row) {
			this.$Modal.confirm({
				title: '提示',
				content: '是否发送短信？',
				onOk: () => {
					var params = {
						Tel: row.Tel,
						type: 5
					}
					this.$post('api/Login/sendCode', params).then(res => {
						if (res.code == 1) {
							this.getData();
							this.$Message.success('发送成功')
						} else {
							this.$Message.error(res.msg)
						}
					})
				},
				onCancel: () => {
				}
			});
		},
		getData() {
			var params = {
				page: this.page,
				pageSize: this.pageSize,
				keyword: this.keyword,
				Status: this.userName == 4 ? '' : this.userName
			}
			this.$post('api/manage.SupplierManage/supplierList', params).then(res => {
				if (res.code == 1) {
					this.data1 = res.data.data;
					if (this.data1.length > 0) {
						for (let i in this.data1) {
							if (this.data1[i].Comment && this.data1[i].Comment.indexOf(this.keyword) > -1) {
								this.data1[i].CommentKeyword = this.keyword;
								this.data1[i].CommentKbefore = this.data1[i].Comment.substr(0, this.data1[i].Comment.indexOf(this.keyword));
								this.data1[i].CommentKafter = this.data1[i].Comment.substr(this.data1[i].Comment.indexOf(this.keyword)+this.keyword.length);
							} else {
								this.data1[i].CommentKeyword = '';
								this.data1[i].CommentKbefore = '';
								this.data1[i].CommentKafter = this.data1[i].Comment ? this.data1[i].Comment : '';
							}
						}
					}
					console.log(this.data1)
					this.Count = res.data.all_num;
				}
			})
		},
		download(item) {
			const link = document.createElement('a');
			link.download = item.Path;
			link.href = this.imgUrl + item.Path;
			link.target = '_blank';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		confirmVerify(Status) {//确认认证
			let Star = ''
			if (this.Detail.SupplierRate == 1) {
				Star = '一星'
			} else if (this.Detail.SupplierRate == 2) {
				Star = '二星'
			} else if (this.Detail.SupplierRate == 3) {
				Star = '三星'
			} else if (this.Detail.SupplierRate == 4) {
				Star = '四星'
			} else if (this.Detail.SupplierRate == 5) {
				Star = '五星'
			}
			var params = {
				ID: this.UserID,
				AuditComment: this.Remark,
				SupplierRate: Star,
				Comment: this.Detail.Comment,
				Status: Status
			}
			if (Status == 3) {
				if (Star == 0) {
					this.$Message.error('请给供应商评级');
					return false;
				}
			}
			this.$post('api/manage.SupplierManage/supplierAudit', params).then(res => {
				if (res.code == 1) {
					if (Status == 1) {
						this.Detail.Status = 1;
					}
					this.showRemark = false;
					this.$Message.success(res.msg);
				} else {
					this.$Message.error(res.msg);
				}
			})
		},
		checkImg(item, index) {
			this.valueProtrait = index;
			this.showPortrait = true;
		},
		cancelVer() {
			if (this.Remark) {
				this.confirmVerify(1);
			} else {
				this.$Message.error('请输入取消认证的原因');
			}
		},
		cancelVerify() {//取消认证
			this.showRemark = true;
			this.Remark = '';
		},
		getDetail(row) {
			var params = {
				ID: row.ID
			}
			this.UserID = row.ID;
			this.$post('api/manage.SupplierManage/supplierDetails', params).then(res => {
				if (res.code == 1) {
					this.showDetail = true;
					this.Detail = res.data;

					this.data = res.data.FinishProjectNum;
					if (this.Detail.TelAddress) {
						// this.Detail.TelAddress=JSON.parse(res.data.TelAddress);
						this.Detail.TelAddress = this.$pcaa[86][res.data.TelAddress.Province] + this.$pcaa[res.data.TelAddress.Province][res.data.TelAddress.City] + this.$pcaa[res.data.TelAddress.City][res.data.TelAddress.Area]
					}
					// 
					if (this.Detail.SupplierRate == '一星') {
						this.Detail.SupplierRate = 1
					} else if (this.Detail.SupplierRate == '二星') {
						this.Detail.SupplierRate = 2
					} else if (this.Detail.SupplierRate == '三星') {
						this.Detail.SupplierRate = 3
					} else if (this.Detail.SupplierRate == '四星') {
						this.Detail.SupplierRate = 4
					} else if (this.Detail.SupplierRate == '五星') {
						this.Detail.SupplierRate = 5
					} else {
						this.Detail.SupplierRate = 0
					}
					this.FilePath = [];
					if (res.data.FilePath) {
						res.data.FilePath.forEach(item => {
							if (item.split('.')[1] == 'mp4' || item.split('.')[1] == 'MP4') {
								this.FilePath.push({ Name: '视频', Path: item })
							} else if (item.split('.')[1] == 'pdf') {
								this.FilePath.push({ Name: 'pdf', Path: item })
							}
						})
					}

					if (this.Detail.Address) {
						this.Detail.place = this.$pcaa[86][this.Detail.Address.Province] + this.$pcaa[this.Detail.Address.Province][this.Detail.Address.City] + this.$pcaa[this.Detail.Address.City][this.Detail.Address.Area]
					} else {
						this.Detail.place = '';
					}
				}
			})
		},
		rowClassName(row, index) {
			if ((index % 2) === 1) {
				return 'demo-table-info-row';
			}
			return '';
		}
	}
}
</script>
<style lang="less" scoped>
@deep: ~">>>";
// 分类搜索
.searchcondition {
	margin-bottom: 10px;
}
.searchcondition span {
	display: inline-block;
	width: 50px;
	font-size: 12px;
	margin-right: 10px;
	color: #000;
	font-weight: bold;
}
.searchcondition {
	.ivu-checkbox-wrapper {
		margin-right: 15px;
		.ivu-checkbox {
			opacity: 0;
		}
	}
	.ivu-checkbox-wrapper-checked {
		background: rgba(37, 141, 205, 0.05);
		color: #258dcd;
	}
}
.ivu-modal {
	top: 44px;
}
.workDisplay div {
	float: left;
	margin-left: 10px;
}
.box {
	padding: 30px;
	box-sizing: border-box;
	height: 100%;
	> .ivu-row {
		margin-top: 20px;
		background-color: #fff;
		padding: 20px 10px;
		box-shadow: 0px 3px 5px #d9dde3;
		> .ivu-col {
			margin-right: 10px;
		}
	}
	.tab {
		height: calc(~"100% - 129px");
		margin-top: 20px;
		background-color: #fff;
		padding: 10px;
		box-shadow: 0px 3px 5px #d9dde3;
	}
}
.table-c {
	table {
		border-right: 1px solid #caf2ff;
		border-bottom: 1px solid #caf2ff;
		td {
			border-left: 1px solid #caf2ff;
			padding: 10px;
			text-align: center;
			border-top: 1px solid #caf2ff;
			font-size: 12px;
		}
		.label {
			background-color: #f0fcff;
			color: #0092c1;
		}
	}
}
.header-modal {
	padding: 10px 15px;
	color: #fff;
	background-color: #01aae3;
	font-size: 22px;
	display: flex;
	position: relative;
	span {
		margin-left: 20px;
		margin-top: 3px;
	}
	.close {
		width: 22px;
		height: 22px;
		position: absolute;
		right: 14px;
		cursor: pointer;
		top: 14px;
	}
}
.content-modal {
	padding: 20px 20px 0;
}
.input-text {
	width: 100%;
	border-radius: 5px;
	border: 1px solid #eee;
	height: 30px;
}
// 给备注列，添加样式，加省略号
@{deep} .tabel-comment {
	.ivu-table-cell {
		width: 200px;
		margin: 0 auto;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}
}
</style>


// WEBPACK FOOTER //
// src/view/SupplierList/SupplierList.vue